import { render, staticRenderFns } from "./PackageFailedModal.vue?vue&type=template&id=2b2f48cb&scoped=true&"
import script from "./PackageFailedModal.vue?vue&type=script&lang=js&"
export * from "./PackageFailedModal.vue?vue&type=script&lang=js&"
import style0 from "./PackageFailedModal.vue?vue&type=style&index=0&id=2b2f48cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f48cb",
  null
  
)

export default component.exports